import React, { Fragment } from "react";
import { Alerts, P } from "../../../../AbstractElements";
import { Col } from "reactstrap";
import { DARK_THEME_LISTS } from "../../../../Data/UiKit/Alert";
import { Href } from "../../../../Constant";

export const DarkThemeRightSection = () => {
  return (
    <Col xl="6">
      <P className="mb-0 ">Warning Alert</P>
      <Alerts color="warning" className="dark">
        <P>
          {`This is a `}
          <a className="alert-link text-white " href={Href}>warning alert</a> with an example link.Check it out.
        </P>
      </Alerts>
      {DARK_THEME_LISTS.map(({ title, color, className }, index) => (
        <Fragment key={index}>
          <P className="mb-0">{title}</P>
          <Alerts color={color} className="dark">
            <P>
              This is a
              <a className={`alert-link text-${className ? className : "light"} text-lowercase`} href={Href}>
                {title}
              </a>
              with an example link.Check it out.
            </P>
          </Alerts>
        </Fragment>
      ))}
    </Col>
  );
};
